/* eslint-disable no-param-reassign */

export default {
    namespaced: true,

    state: {
        notifications: [],
    },

    getters: {
        hasId: state => id => state.notifications.find(n => n.id === id) !== undefined,
    },

    mutations: {
        push(state, notification) {
            state.notifications = state.notifications.concat([notification]);
        },

        pop(state, id) {
            state.notifications = state.notifications.filter(item => item.id !== id);
        },
    },

    actions: {
        add({ commit }, notification) {
            const data = notification;

            data.id = Date.now();

            if (data.timeout === undefined) {
                data.timeout = 8000;
            }

            commit('push', data);

            if (data.timeout > 0 && !data.sticky) {
                setTimeout(() => {
                    commit('pop', data.id);
                }, data.timeout);
            }

            return data.id;
        },
    },
};
